import { XMarkIcon } from "@heroicons/react/20/solid";
import { useMemo } from "react";
import { connect } from "react-redux";
import { Actions as COMPANYACTIONS } from "../../../store/actions/companyActions";
import { Actions as PAYROLLACTIONS } from "../../../store/actions/payrollActions";
import FyorinPayments from "../../integrations/fyorin/FyorinPayments";
import PaymentIntegrationPayments from "../../integrations/paymentIntegrations/PaymentIntegrationPayments";
import DownloadSepa from "./DownloadSepa";

const BankTransferModal = ({ paymentIntegrations, period, setBankTransferModal, isModalOpen }) => {
	const modalContent = useMemo(() => {
		if (paymentIntegrations?.[0] == "Fyorin") return <FyorinPayments />;
		if (typeof isModalOpen === "string") return <PaymentIntegrationPayments integration={isModalOpen} />;
		else return <DownloadSepa />;
	}, [JSON.stringify(paymentIntegrations), period?.id]);

	if (!isModalOpen) return null;

	console.log("period", period);

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "40%", marginTop: "15%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={setBankTransferModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">
								{paymentIntegrations?.[0] ? "Payment" : "Bank File"} For Period {period.period},{" "}
								{period?.year}
							</h3>
						</div>

						{modalContent || null}

						<div className="clearfix" />
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const paymentIntegrations = Object.values(state.integration?.payment || {})?.reduce((prev, curr) => {
		prev.push(curr.name);
		return prev;
	}, []);
	return {
		bank: state.company?.settings?.bankDetails?.[0]?.bic == "VALLMTMT" ? "bov" : "hsbc",
		period: state?.company?.bankTransferModal?.period,
		isModalOpen: state?.company?.bankTransferModal?.isOpen,
		paymentIntegrations,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setBankTransferModal: () => dispatch(COMPANYACTIONS.setBankTransferModal(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BankTransferModal);
